import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import { User } from './modules/User'
import { Project } from './modules/Project'
import { ProjectSortTask } from './modules/ProjectSortTask'
import { Task } from './modules/Task'
import { Tasks } from './modules/Tasks'
import { Dashboard } from './modules/Dashboard'
import { Designers } from './modules/Designers'
import { CreateTask } from './modules/CreateTask'
import { ProjectNotifications } from './modules/Projectnotifications'
import { Messages } from './modules/Messages'
import { WorkLog } from './modules/WorkLog'

export const store = new Vuex.Store({
  modules: {
    User,
    Project,
    ProjectSortTask,
    Task,
    Tasks,
    Dashboard,
    Designers,
    CreateTask,
    ProjectNotifications,
    Messages,
    WorkLog
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js